/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

import * as url from "helper/UrlHelper";
import { postData, getData, putData } from "utils/Gateway";

import NoteSection from "components/Common/NoteComponent/NoteSection";

import { useTranslation } from "react-i18next";
import { reactSelectStyle } from "Config/Config";

const SaveLeadPopup = ({
  selectedTagId,
  setSelectedTagId,
  selectedComponentId,
  setSelectedComponentId,
  setReloadData,
}) => {
  const params = useParams();
  const history = useHistory();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const ecosystemSlug = localStorage.getItem("ecosystemslug");

  const { t } = useTranslation(); //for translation

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [website, setWebsite] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [companyName, setCompanyName] = useState("");

  const [followersOptions, setFollowersOptions] = useState([]);
  const [followersValue, setFollowersValue] = useState([]);
  const [selectedFollowers, setselectedFollowers] = useState([]);
  const [followersInput, setFollowersInput] = useState("");

  const [moderatorId, setModeratorId] = useState(userInfo._id.toString());

  const [isSending, setIsSending] = useState(false);

  const [noteList, setNoteList] = useState([]);
  const [invoiceNote, setInvoiceNote] = useState("");

  const [noteAccessUserList, setNoteAccessUserList] = useState([]);
  const [selectedLeadId, setSelectedLeadId] = useState(null);

  const [validation, setValidation] = useState({
    firstNameWarning: false,
    emailAddressWarning: false,
    notValidMail: false,
  });

  // Interest and Industry states
  const [interestOptions, setInterestOptions] = useState([]);
  const [interestValue, setInterestValue] = useState([]);
  const [industryOptions, setIndustryOptions] = useState([]);
  const [industryValue, setIndustryValue] = useState([]);

  //function for get followers list
  const getFollowersList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USERLIST_OPTIONS +
        `?token=${token}&userstringinput=${followersInput}`;

      const response = await getData(requestUrl);

      if (response.status) {
        if (response.data.length > 0) {
          setFollowersOptions(response.data);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  //select followers
  const followersSelectionHandler = (val) => {
    //console.log('followersSelectionHandler', val);

    setFollowersValue(val);
    setselectedFollowers(val.map((item) => item.value));
  };

  //function for get followers input
  const followersInputHandler = (val) => {
    setFollowersInput(val);
  };

  const validationHandler = () => {
    let isValid = true;

    if (firstName === "") {
      setValidation((prevState) => ({ ...prevState, firstNameWarning: true }));
      isValid = false;
    }

    if (emailAddress === "") {
      setValidation((prevState) => ({
        ...prevState,
        emailAddressWarning: true,
      }));
      isValid = false;
    }

    if (emailAddress !== "") {
      const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (!emailAddress.match(mailformat)) {
        setValidation((prevState) => ({
          ...prevState,
          notValidMail: true,
        }));
        isValid = false;
      }
    }

    // if valid then unset the warning
    if (isValid) {
      setValidation((prevState) => ({
        ...prevState,
        firstNameWarning: false,
        emailAddressWarning: false,
        notValidMail: false,
      }));
    }

    return isValid;
  };

  // Fetch options from ecosystem API (same as SaveEcosystemPopup)
  useEffect(() => {
    const fetchEcosystemOptions = async () => {
      try {
        const requestUrl =
          url.API_BASE_URL +
          url.API_GET_ECOSYSTEM_BY_SLUG +
          `/${ecosystemSlug}?token=${token}`;
        const response = await getData(requestUrl);
        if (response.status) {
          setInterestOptions(
            response.data.interest
              ? response.data.interest.map((item) => ({
                  label: item,
                  value: item,
                }))
              : [],
          );
          setIndustryOptions(
            response.data.industry
              ? response.data.industry.map((item) => ({
                  label: item,
                  value: item,
                }))
              : [],
          );
        }
      } catch (error) {
        // silent fail
      }
    };
    fetchEcosystemOptions();
  }, [ecosystemSlug, token]);

  // Handlers for Interest/Industry
  const handleInterestChange = (val) => {
    setInterestValue(val);
    setInterestOptions((prev) => {
      const newOptions = val.filter(
        (item) => !prev.some((opt) => opt.value === item.value),
      );
      return [...prev, ...newOptions];
    });
  };
  const handleIndustryChange = (val) => {
    setIndustryValue(val);
    setIndustryOptions((prev) => {
      const newOptions = val.filter(
        (item) => !prev.some((opt) => opt.value === item.value),
      );
      return [...prev, ...newOptions];
    });
  };

  const saveUpdateLeadHandler = async () => {
    if (validationHandler()) {
      try {
        setIsSending(true);

        let leadData = {
          name: firstName,
          surname: lastName,
          email: emailAddress,
          phone: phoneNumber,
          company: companyName,
          dob: dateOfBirth,
          website,
          followers: selectedFollowers,
          source: `${ecosystemSlug} Backend`,
          interest: interestValue.map((item) => item.value),
          industry: industryValue.map((item) => item.value),
        };

        console.log("leadData", leadData);

        let requestUrl = url.API_BASE_URL;
        let response = {};

        if (selectedComponentId) {
          requestUrl =
            requestUrl +
            url.API_UPDATE_LEAD +
            `/${selectedComponentId}` +
            `?token=${token}`;

          console.log("udpate requestUrl", requestUrl);

          response = await putData(requestUrl, leadData);

          console.log("update response", response);
        } else {
          // add tag too
          //console.log('setSelectedTagId', setSelectedTagId);

          leadData.defaultTag = selectedTagId;

          requestUrl = requestUrl + url.API_CREATE_LEAD + `?token=${token}`;

          console.log("create requestUrl", requestUrl);

          response = await postData(requestUrl, leadData);

          console.log("create response", response);
        }

        setIsSending(false);

        if (response.status) {
          let offCanvasPopup = document.querySelector("#saveLeadPopup");
          let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
          offCanvas.hide();

          setSelectedComponentId(null);

          setReloadData(true);
        }
      } catch (error) {
        console.error(error.message);
      }
    }
  };

  const closeHandler = () => {
    setSelectedComponentId(null);
    setSelectedTagId(null);

    setFirstName("");
    setLastName("");
    setEmailAddress("");
    setPhoneNumber("");
    setWebsite("");
    setDateOfBirth("");
    setCompanyName("");
    setFollowersValue(null);
    setModeratorId(userInfo._id.toString());
    setInterestValue([]);
    setIndustryValue([]);

    setValidation({
      firstNameWarning: false,
      emailAddressWarning: false,
      notValidMail: false,
    });
  };

  useEffect(() => {
    if (followersInput.length > 0) {
      getFollowersList();
    }
  }, [followersInput]);

  const getLeadDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_LEAD_DETAILS +
        `/${selectedComponentId}?token=${token}`;

      const response = await getData(requestUrl);

      console.log("response", response);

      if (response.status) {
        setFirstName(response.data.name);
        setLastName(response.data.surname);
        setEmailAddress(response.data.email);
        setPhoneNumber(response.data.phone);
        setWebsite(response.data.website);
        setDateOfBirth(response.data.dob);
        setCompanyName(response.data.company);

        //console.log('followersarr', response.data.followersarr);

        setFollowersValue(response.data.followersarr);

        if (response.data.moderator && response.data.moderator._id) {
          setModeratorId(response.data.moderator._id.toString());
        }

        setInterestValue(
          response.data.interestarr
            ? response.data.interestarr.map((item) => ({
                label: item,
                value: item,
              }))
            : [],
        );
        setIndustryValue(
          response.data.industryarr
            ? response.data.industryarr.map((item) => ({
                label: item,
                value: item,
              }))
            : [],
        );

        // Show the offcanvas after setting the state
        let offCanvasPopup = document.querySelector("#saveLeadPopup");
        let offCanvas = new bootstrap.Offcanvas(offCanvasPopup);
        offCanvas.show();
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  // get lead details from component id
  useEffect(() => {
    if (selectedComponentId) {
      getLeadDetails();
    }
  }, [selectedComponentId]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="saveLeadPopup"
      aria-labelledby="saveLeadPopup"
    >
      {/* Styled header similar to SaveEcosystemPopup */}
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              person
            </span>
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasLabelDetailsLabel"
            >
              {selectedComponentId || userInfo._id.toString() === moderatorId
                ? t("Save Lead")
                : t("View Lead")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {selectedComponentId
                ? t("Edit lead details")
                : t("Create a new lead")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={closeHandler}
        ></button>
      </div>

      <div className="offcanvas-body p-4">
        <div className="row">
          <div className="col-lg-8">
            <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
              <form
                onSubmit={(e) => e.preventDefault()}
                className="d-flex flex-column h-100"
              >
                <div className="fields-container flex-fill">
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <div className="row">
                      <div className="col">
                        <label
                          htmlFor="firstName"
                          className="d-block fs-sm fw-semibold mb-2 text-dark"
                        >
                          {t("First Name")}{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control fs-sm shadow-none${validation.firstNameWarning ? " is-invalid" : " border border-gray-300"}`}
                          id="firstName"
                          value={firstName}
                          onChange={(e) => setFirstName(e.target.value)}
                          placeholder={t("Enter first name")}
                        />
                        {validation.firstNameWarning && (
                          <div className="invalid-feedback">
                            {t("First Name is required")}
                          </div>
                        )}
                      </div>
                      <div className="col">
                        <label
                          htmlFor="lastName"
                          className="d-block fs-sm fw-semibold mb-2 text-dark"
                        >
                          {t("Last Name")}
                        </label>
                        <input
                          type="text"
                          className="form-control fs-sm shadow-none border border-gray-300"
                          id="lastName"
                          value={lastName}
                          onChange={(e) => setLastName(e.target.value)}
                          placeholder={t("Enter last name")}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="emailAddress"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Email")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      className={`form-control fs-sm shadow-none${validation.emailAddressWarning ? " is-invalid" : " border border-gray-300"}`}
                      id="emailAddress"
                      value={emailAddress}
                      onChange={(e) => setEmailAddress(e.target.value)}
                      placeholder={t("Enter email address")}
                    />
                    {validation.emailAddressWarning && (
                      <div className="invalid-feedback">
                        {t("Email is required")}
                      </div>
                    )}
                  </div>

                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <div className="row">
                      <div className="col">
                        <label
                          htmlFor="phoneNumber"
                          className="d-block fs-sm fw-semibold mb-2 text-dark"
                        >
                          {t("Phone")}
                        </label>
                        <input
                          type="text"
                          className="form-control fs-sm shadow-none border border-gray-300"
                          id="phoneNumber"
                          value={phoneNumber}
                          onChange={(e) => setPhoneNumber(e.target.value)}
                          placeholder={t("Enter phone number")}
                        />
                      </div>
                      <div className="col">
                        <label
                          htmlFor="dateOfBirth"
                          className="d-block fs-sm fw-semibold mb-2 text-dark"
                        >
                          {t("Date of Birth")}
                        </label>
                        <input
                          type="date"
                          className="form-control fs-sm shadow-none border border-gray-300"
                          id="dateOfBirth"
                          value={dateOfBirth}
                          onChange={(e) => setDateOfBirth(e.target.value)}
                          placeholder={t("Select date of birth")}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <div className="row">
                      <div className="col">
                        <label
                          htmlFor="website"
                          className="d-block fs-sm fw-semibold mb-2 text-dark"
                        >
                          {t("Website")}
                        </label>
                        <input
                          type="text"
                          className="form-control fs-sm shadow-none border border-gray-300"
                          id="website"
                          value={website}
                          onChange={(e) => setWebsite(e.target.value)}
                          placeholder={t("Enter website URL")}
                        />
                      </div>
                      <div className="col">
                        <label
                          htmlFor="company"
                          className="d-block fs-sm fw-semibold mb-2 text-dark"
                        >
                          {t("Company")}
                        </label>
                        <input
                          type="text"
                          className="form-control fs-sm shadow-none border border-gray-300"
                          id="company"
                          value={companyName}
                          onChange={(e) => setCompanyName(e.target.value)}
                          placeholder={t("Enter company name")}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Interest Multiselect */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="interest"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Interest")}
                    </label>
                    <CreatableSelect
                      isMulti
                      placeholder={t("Type or create interests")}
                      options={interestOptions}
                      value={interestValue}
                      onChange={handleInterestChange}
                      styles={reactSelectStyle("3px", "6px", true, false)}
                    />
                  </div>
                  {/* Industry Multiselect */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="industry"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Industry")}
                    </label>
                    <CreatableSelect
                      isMulti
                      placeholder={t("Type or create industries")}
                      options={industryOptions}
                      value={industryValue}
                      onChange={handleIndustryChange}
                      styles={reactSelectStyle("3px", "6px", true, false)}
                    />
                  </div>

                  {userInfo._id.toString() === moderatorId ? (
                    <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                      <label
                        htmlFor="followers"
                        className="d-block fs-sm fw-semibold mb-2 text-dark"
                      >
                        {t("Followers")}
                      </label>
                      <Select
                        isMulti
                        placeholder={t("Type user name or email")}
                        options={followersOptions}
                        value={followersValue}
                        onChange={(val) => followersSelectionHandler(val)}
                        onInputChange={(val) => {
                          followersInputHandler(val);
                        }}
                        styles={reactSelectStyle("3px", "6px", true, false)}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                {userInfo._id.toString() === moderatorId ? (
                  <div className="d-flex justify-content-end">
                    <button
                      type="submit"
                      className="btn btn-primary d-flex align-items-center gap-2"
                      onClick={saveUpdateLeadHandler}
                      disabled={isSending}
                    >
                      {isSending ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          {t("Saving...")}
                        </>
                      ) : (
                        <>
                          <span className="material-symbols-outlined me-1">
                            save
                          </span>
                          {t("Save Lead")}
                        </>
                      )}
                    </button>
                  </div>
                ) : null}

                {(validation.firstNameWarning ||
                  validation.emailAddressWarning ||
                  validation.notValidMail) && (
                  <div className="alert alert-danger ms-2 mt-3">
                    {t("Please correct the highlighted fields before saving.")}
                  </div>
                )}
              </form>
            </div>
          </div>
          <div className="col-lg-4">
            {selectedComponentId && (
              <NoteSection
                noteAccessUserList={noteAccessUserList}
                moduleName="LEAD"
                leadId={selectedComponentId}
              />
            )}
          </div>
        </div>
      </div>
      {/* Sticky styled footer */}
      <div
        className="offcanvas-footer p-3 bg-white border-top d-flex justify-content-end"
        style={{ position: "sticky", bottom: 0, zIndex: 10 }}
      ></div>
    </div>
  );
};

export default SaveLeadPopup;
